// extracted by mini-css-extract-plugin
export default {"link":"link__pG5dw","row":"row__vYj20","column":"column__cCQIf","body":"body__BUR1h","core":"core__Xhuku","sidebar":"sidebar__RUKIZ","textbox":"textbox__Ro985"};